// extracted by mini-css-extract-plugin
export default {"modal":"InfoModal_modal__CK7cp","bottom-shadow":"InfoModal_bottom-shadow__p1Yqj","close-btn":"InfoModal_close-btn__OpJVV","left-align-footer":"InfoModal_left-align-footer__3Pklt"};